import { Component } from '@angular/core';

@Component({
  selector: 'app-tabs-limit-exceeded',
  template: `<nz-result nzStatus="error" nzTitle="Max Tabs Limit Exceeded!">
  <div nz-result-extra>Please close this tab to continue.</div>
</nz-result>`,
})
export class MaxTabsLimitExceededComponent {

}
